import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import RemoveTaskForm from '../forms/remove-task-form';
import { ICheckItem, IMemoMessage } from '../../../models/forms/ICompleteProcess';
import { ProcessTypeEnum } from '../../../constants/enums';

interface IRemoveTaskFormModalProps {
  id: string;
  modalClosed: () => void;
  Count: number;
  ProcessId: string;
  startTime: string;
  Duration: number;
  NoOfOperators: number;
  CheckItemList: ICheckItem[];
  MemoMessage: IMemoMessage[];
  Dimensions: [];
  BOM: any[];
  TeplarList: any[];
  processType: number
}

const RemoveTask = (props: IRemoveTaskFormModalProps) => {
  const { processStore, groupSettingStore, operatorStore } = useStore();
  const {removeForAbnormalityState, RemoveForAbnormality, resetRemoveForAbnormalityState} = operatorStore;

  const initialValues = { AbnormalityRemark: '' };

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  // useEffect(() => {
  //   if (props.id > 0) {
  //     GetProcessByIdService(props.id);
  //   }
  // }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (removeForAbnormalityState.success) {
      toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [removeForAbnormalityState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (removeForAbnormalityState.error) {
      toast.error(formatMessage(removeForAbnormalityState.error));
      // resetremoveForAbnormalityState();
    }
  }, [removeForAbnormalityState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = ({AbnormalityRemark}) => {
    // var addObj: IAddGroupCode = {
    //   ...values,
    //   TrayId: props.selectedAssignedRows.join(','),
    //   TenantId: Number(getTenantIdFromLocalStorage()),
    // };

    // if (props.id < 0) {
    //   AddGroupCodeService(addObj);
    // }
    var obj = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      TrayId: [props.id],
      AbnormalityRemark,
      Count: props.Count,
      CurrentState: '',
      Duration: props.Duration,
      EndTime: new Date().toISOString(),
      StartTime: props.startTime || new Date().toISOString(),
      NoOfOperators: props.NoOfOperators,
      ProcessId: Number(props.ProcessId),
      CheckItemList: props.CheckItemList,
      MemoMessage: props.MemoMessage,
      DimensionList: props.Dimensions,
      BOMCheckList: props.BOM,
      TeplarList: props.TeplarList,
      IsFollowUp: props.processType === ProcessTypeEnum.FollowUpPicking,
    };
    RemoveForAbnormality(obj);
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={Number(props.id)}
        className="correction-modal fancy-modal"
        addHeader="assign_group_code"
        updateHeader="remove"
        onModalClosed={onModalClosed}
        isLoading={removeForAbnormalityState.inProgress}
      >
        <RemoveTaskForm
          id={String(props.id)}
          initialValues={initialValues}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={removeForAbnormalityState.inProgress}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(RemoveTask);
